export const appRouterPath = {
  airtable: {
    root: '/airtable',
    base: {
      root: '/airtable/:base',
      table: '/airtable/:base/:table',
    },
  },
} as const;
